import { render, staticRenderFns } from "./subscribeDetail.vue?vue&type=template&id=16473fb6&scoped=true&"
import script from "./subscribeDetail.vue?vue&type=script&lang=js&"
export * from "./subscribeDetail.vue?vue&type=script&lang=js&"
import style0 from "./subscribeDetail.vue?vue&type=style&index=0&id=16473fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16473fb6",
  null
  
)

export default component.exports